import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import bus from '@/utils/bus';
import { SNACKBAR_TYPES } from '@/utils/constants';
import { numberInputHandler } from '@/utils/helper';
import {
  account as accountRule,
  identification as identificationRule,
  password,
  required,
} from '@/utils/validators';

import ForgetPassword from '../ForgetPassword/ForgetPassword.vue';

export default {
  name: 'LoginForm',
  components: {
    ForgetPassword,
  },
  setup() {
    return { loginValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      forgetPwdDialog: false,
      form: {
        account: '',
        identification: '',
        password: '',
      },
      hasIdentificationParam: false,
    };
  },
  computed: {
    ...mapState('user', {
      logging: ({ logging }) => logging,
    }),
  },
  mounted() {
    this.fillValues();
  },
  methods: {
    ...mapActions('user', {
      userLogin: 'USER_LOGIN',
    }),
    async fillValues() {
      const {
        account = '',
        identification: id = '',
        pwd = '',
      } = this.$route?.query || {};

      const identification = decodeURIComponent(id);
      this.form.identification = identification;
      const valid = await this.loginValidator$.form.identification.$validate(identification);

      this.loginValidator$.form.identification.$dirty = false;
      this.hasIdentificationParam = valid;
      this.form.identification = valid ? identification : '';

      this.form.account = decodeURIComponent(account);
      this.form.password = decodeURIComponent(pwd);
    },
    async login() {
      const valid = await this.loginValidator$.form.$validate();
      if (!valid) return;

      try {
        const {
          id,
          name,
          token,
        } = await this.userLogin(this.form);

        bus.$emit('TEMP_COMPANY_NAME', name);
        if (id && token) {
          this.$router.push('/menu');
        } else if (!id) {
          this.$router.push('/choose_team');
        }
      } catch (error) {
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          msg: error?.message || '',
        });
      }
    },
    getErrorMsgs(field) {
      return this.loginValidator$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return !!this.loginValidator$.form?.[field]?.$errors?.length;
    },
    onNumberInputKeydown(event) {
      numberInputHandler(event);
    },
    toggleForgetPwdModal(status = false) {
      this.forgetPwdDialog = status;
    },
  },
  validations() {
    return {
      form: {
        account: { required: required('帳號'), accountRule },
        password: { required: required('密碼'), password },
        identification: { required: required('統一編號'), identificationRule },
      },
    };
  },
};
